<template>
  <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="modalId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{trans('invoices.send_copy_modal.header')}}</h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div  class="modal-body" :class="'text-success'">
          <div class="form-group row py-2">
            <label for="email" class="col-md-4 col-form-label text-md-right">
              {{trans('invoices.send_copy_modal.mail')}}
            </label>
            <div class="col">
              <input
                v-model="currentInvoicingEmail"
                id="email"
                type="email"
                class="form-control"
                name="email"
                required="required"
              >
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            {{trans('invoices.send_copy_modal.cancel')}}
          </button>
          <button
            @click="send"
            data-dismiss="modal"
            type="submit"
            class="btn btn-success"
          >
            {{trans('invoices.send_copy_modal.send')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimpleModal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    invoicingEmail: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      currentInvoicingEmail: this.invoicingEmail
    }
  },
  emits: [
    "send",
  ],
  methods: {
    send() {
      this.$emit("send", this.currentInvoicingEmail);
      this.currentInvoicingEmail = this.invoicingEmail;
    }
  }
}
</script>
